import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import "components/UploadedFilesPreview/UploadedFilesPreview.scss";
import { usePermanentRealTimeUser } from "hooks";
import { getNameFromURL } from "utils/common";
import { formatDate } from "utils/dateHelperFunctions";

export type PreviewAttachment = {
  url: string;
  name?: string;
  created_on?: string;
  user_id?: number;
  username?: string;
};

type UploadedFilesPreviewProps = {
  attachments: PreviewAttachment[];
  disabled?: boolean;
  fromAPI?: boolean;
  onDeleteAttachment: (url: string) => void;
};

export const UploadedFilesPreview = ({ attachments, onDeleteAttachment, disabled, fromAPI = false }: UploadedFilesPreviewProps) => {
  const { t } = useTranslation();

  const { user } = usePermanentRealTimeUser();

  const getUsername = (attachment: PreviewAttachment) => {
    if (fromAPI && !attachment.user_id) return t("v8_public_api", "Public API");
    if (attachment.username) return attachment.username;
    if (user?.username) return user.username;

    return "";
  };

  if (!attachments.length) return null;

  return attachments.map(({ url, name, created_on, user_id, username }) => (
    <div className="add-update-attachments-container" key={url}>
      <div className="attachment-name-container">
        <Icon className="image" />
        <span className="attachment-name">{name || getNameFromURL(url)}</span>
      </div>

      <div>
        <span className="attachment-uploaded-by">
          {t("v8_uploaded_by", "Uploaded by")} {getUsername({ url, name, created_on, user_id, username })}
        </span>
        {created_on ? <span className="attachment-uploaded-date">{formatDate(created_on, DATE_FORMATS_FNS.dateMonthYearTime)}</span> : null}
        <Icon className="trash" onClick={() => onDeleteAttachment(url)} disabled={disabled} />
      </div>
    </div>
  ));
};
